import { v4 } from "uuid";
import { USER_INFO_LOADING_FAILED, USER_INFO_LOADING_SUCCESS } from "./types";
import { panels, USER_INFO_ADDRESS } from "../../variables";
import { restartPanelsHistory, setActivePanel } from "./panelsActions";
import store from "../store";
import { logout } from "./userActions";
import Api from "../../api";
import { HealthCheckEvents } from "../../api/types";

export const userInfoLoadingStarted = (
  enteredOms,
  redirectAfterLoading = true
) => (dispatch) => {
  const healthCheckInstance = Api.healthCheckFor(HealthCheckEvents.getUserData);

  console.log("[userInfoLoadingStarted]");
  return Api.instance.get(USER_INFO_ADDRESS + Math.random(), {
    method: "get",
    withCredentials: true,
  })
    .then((response) => {
      if (enteredOms) {
        const updatedUserInfo = { ...response.data };
        updatedUserInfo.person.docs.push({
          type: "MDCL_PLCY",
          number: enteredOms,
        });
        dispatch(
          userInfoLoadingSuccess({
            ...updatedUserInfo,
            sessionId: v4(),
          })
        );
      } else {
        dispatch(
          userInfoLoadingSuccess({
            ...response.data,
            sessionId: v4(),
          })
        );
      }

      healthCheckInstance.sendSuccess();

      // Закоментирована для тестов
      if (redirectAfterLoading) {
        if (containsOMS(response.data) || enteredOms) {
          dispatch(restartPanelsHistory());
        } else {
          dispatch(setActivePanel(panels.oms));
        }
      }
    })
    .catch((error) => {
      console.log('[userInfoLoadingStarted] FAILED');
      console.error(error);
      dispatch(logout());
      healthCheckInstance.sendFailure({ browserError: error.message });
    });
};

const containsOMS = (userInfo) => {

  const docs = userInfo?.person?.docs ?? [];

  for (let i = 0; i < docs.length; i++) {
    if (docs[i].type === "MDCL_PLCY") {
      return !!docs[i].number
    }
  }
  return false;
};

export const userInfoLoadingSuccess = (userInfo) => {
  return {
    type: USER_INFO_LOADING_SUCCESS,
    payload: userInfo,
  };
};

export const userInfoLoadingFailed = (e) => {
  return {
    type: USER_INFO_LOADING_FAILED,
    payload: e,
  };
};

export const updateSessionId = () => {
  store.dispatch(userInfoLoadingSuccess({
    ...store.getState().userInfo?.userInfo,
    sessionId: v4(),
  }));
};
